import React from "react";
import SparkleIcon from "Components/common/SparkleIcon";

/**
 * SG-2182 Flow 2 — shown above the sequence list for users who already have
 * sequences. Clicking "Create Sequence" opens a new Copilot conversation with
 * an auto-sent opening message (wired by onClick, from main.js). Inline
 * styles rather than a new SCSS partial, to keep this addition self-contained;
 * the one scoped <style> block below sizes SparkleIcon, which only forwards
 * className (not a style prop).
 */
const CopilotBanner = ({ onClick }) => (
  <div
    className="copilotSequenceBanner"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 20,
      background: "linear-gradient(120deg, #eef1ff 0%, #f8f9ff 60%, #ffffff 100%)",
      border: "1px solid #c7cffe",
      borderRadius: 16,
      padding: "20px 24px",
      marginBottom: 20
    }}
  >
    <style>{`
      .copilotSequenceBanner__iconLg { width: 22px; height: 22px; }
      .copilotSequenceBanner__iconSm { width: 15px; height: 15px; }
    `}</style>
    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: 13,
          background: "#ffffff",
          border: "1px solid #c7cffe",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#3953fb",
          flexShrink: 0,
          boxShadow: "0 2px 8px rgba(57,83,251,0.12)"
        }}
      >
        <SparkleIcon className="copilotSequenceBanner__iconLg" />
      </div>
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1c1e2e" }}>
            Build a sequence by chatting with Copilot
          </span>
          <span
            style={{
              fontSize: 10.5,
              fontWeight: 700,
              color: "#3953fb",
              background: "#ffffff",
              border: "1px solid #c7cffe",
              borderRadius: 6,
              padding: "2px 7px",
              letterSpacing: 0.3
            }}
          >
            NEW
          </span>
        </div>
        <div style={{ fontSize: 12.5, color: "#6b7080", marginTop: 3 }}>
          Answer a few questions. Copilot drafts the whole sequence, steps,
          copy and timing included.
        </div>
      </div>
    </div>
    <button
      type="button"
      id="copilotSequenceBannerBtn"
      onClick={onClick}
      style={{
        background: "#3953fb",
        color: "#ffffff",
        border: "none",
        borderRadius: 10,
        padding: "11px 18px",
        fontSize: 13.5,
        fontWeight: 600,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 7,
        flexShrink: 0
      }}
    >
      <SparkleIcon className="copilotSequenceBanner__iconSm" />
      Create Sequence
    </button>
  </div>
);

export default CopilotBanner;
